export default "__VITE_ASSET__HekwFCkB__"